import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { Location } from './Constants';

export default class SearchBox extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string,
    onPlacesChanged: PropTypes.func
  }

  state = {
      value: null
  }

  render() {
    let { value } = this.state;
    if(this.props.location && !value){
      const location = Location.parse(this.props.location);
      if( location.address ) {
        value = location.address;
      }
    }

    return  <Input
        ref="search_box_input"
        type="text"
        value={ value }
        disabled={this.props.disabled}
        onChange={(e) => this.setState({ value: e.target.value })}
        placeholder="Sélectionnez votre adresse"
    />;
  }

  onPlacesChanged = () => {
    if (this.props.onPlacesChanged) {
      const place = this.searchBox.getPlaces()[0];
      this.props.onPlacesChanged( Location.stringify(place.geometry.location.lat(), place.geometry.location.lng(), place.name + ', ' + place.formatted_address) );
      this.setState({ value: null })
    }
  }

  componentWillReceiveProps(props) {
    if(props.maps && !this.props.maps) {
        var searchBoxInput = ReactDOM.findDOMNode(this.refs.search_box_input);
        this.searchBox = new props.maps.places.SearchBox(searchBoxInput);
        this.searchBox.addListener('places_changed', this.onPlacesChanged);
    }
  }

  componentWillUnmount() {
    // https://developers.google.com/maps/documentation/javascript/events#removing
    if(this.props.maps)
        this.props.maps.event.clearInstanceListeners(this.searchBox);
  }
}


// WEBPACK FOOTER //
// ./src/helper/map/searchBox.js